import { render } from "./aCard2.vue?vue&type=template&id=08bafb4e"
import script from "./aCard2.vue?vue&type=script&lang=js"
export * from "./aCard2.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__